module.exports = __webpack_public_path__ + "static/media/CarteroW01-Light.0284b703.woff";